
import * as React from "react";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";
import { ChevronDown } from "lucide-react";
import { DayPickerProps, CaptionProps } from "react-day-picker";

// Use the correct type from react-day-picker
type CalendarHeaderProps = CaptionProps & {
  fromYear: number;
  toYear: number;
  onMonthChange?: (date: Date) => void;
};

const months = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  displayMonth,
  fromYear,
  toYear,
  onMonthChange,
}) => {
  // Use the month that's passed in
  const currentMonth = displayMonth;
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();

  // Generate years in descending order
  const years = React.useMemo(
    () => Array.from({ length: toYear - fromYear + 1 }, (_, idx) => toYear - idx),
    [fromYear, toYear]
  );

  const handleMonthChange = (newMonthValue: string) => {
    const newMonth = parseInt(newMonthValue, 10);
    if (onMonthChange) {
      const newDate = new Date(year, newMonth, 1);
      onMonthChange(newDate);
    }
  };

  const handleYearChange = (newYearValue: string) => {
    const newYear = parseInt(newYearValue, 10);
    if (onMonthChange) {
      const newDate = new Date(newYear, month, 1);
      onMonthChange(newDate);
    }
  };

  return (
    <div className="flex items-center justify-center py-2 gap-3 relative bg-black/20 w-full z-30">
      <Select
        value={month.toString()}
        onValueChange={handleMonthChange}
      >
        <SelectTrigger className="w-[120px] shadow-none border-0 px-2 py-1 flex items-center justify-center bg-white/20 text-white rounded-md text-base">
          <span className="mr-2">{months[month]}</span>
        </SelectTrigger>
        <SelectContent className="w-[120px] p-0 z-50 bg-black shadow-md">
          {months.map((m, idx) => (
            <SelectItem key={m} value={idx.toString()} className="text-center px-8 py-2 text-base">
              {m}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={year.toString()}
        onValueChange={handleYearChange}
      >
        <SelectTrigger className="w-[90px] shadow-none border-0 px-2 py-1 flex items-center justify-center bg-white/20 text-white rounded-md text-base">
          <span className="mr-2">{year}</span>
        </SelectTrigger>
        <SelectContent className="w-[90px] p-0 z-50 bg-black shadow-md">
          {years.map((y) => (
            <SelectItem key={y} value={y.toString()} className="text-center px-8 py-2 text-base">
              {y}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
